
import { formatAppDate } from '../../lib/dateFormat';
/** Jour calendaire Europe/Paris (`yyyy-MM-dd`). */
export function calendarDayParis(isoOrDate: string | Date): string {
  const d = typeof isoOrDate === 'string' ? new Date(isoOrDate) : isoOrDate;
  return d.toLocaleDateString('en-CA', { timeZone: 'Europe/Paris' });
}

export function todayInputValue(now: Date = new Date()): string {
  return calendarDayParis(now);
}

/** Libellé sous l’étape : `aujourd'hui` ou `11 sept. 2026`. */
export function formatStageDate(iso: string, now: Date = new Date()): string {
  const day = calendarDayParis(iso);
  if (day === calendarDayParis(now)) return "aujourd'hui";
  const [ys, ms, ds] = day.split('-');
  const y = Number(ys);
  const m = Number(ms);
  const d = Number(ds);
  return formatAppDate(new Date(y, m - 1, d));
}
